export const styles = (theme) => ({
    floatingContainer: {
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: theme.zIndex.modal + 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 2,
    },
    chatPanel: {
        width: 380,
        height: 520,
        maxWidth: 'calc(100vw - 32px)',
        maxHeight: '70vh',
        borderRadius: '16px',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.background.default,
        border: `1px solid ${theme.brand.field}`,
    },
    chatHeader: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        padding: '25px 14px',
        display: 'grid',
        gridTemplateColumns: '32px 2fr 32px',
        alignItems: 'center',
        gap: 8,
    },
    headerIconSlot: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    headerAvatar: {
        width: 32,
        height: 32,
        borderRadius: '50%',
        objectFit: 'cover',
        backgroundColor: theme.palette.common.white,
    },
    headerCenter: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        textAlign: 'center',
    },
    headerTitle: {
        fontWeight: 600,
        fontSize: '1rem',
        color: theme.palette.common.white,
        lineHeight: 1.2,
        textAlign: 'center',
        whiteSpace: 'nowrap',
    },
    headerStatus: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
    },
    statusDot: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: theme.palette.warning.main,
    },
    headerSubtitle: {
        fontSize: '0.8rem',
        fontWeight: 500,
        color: theme.palette.common.white,
        opacity: 0.85,
    },
    headerCloseSlot: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    closeButton: {
        color: theme.palette.common.white,
    },
    messagesContainer: {
        flex: 1,
        padding: '10px 14px',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        backgroundColor: theme.brand.chrome,
        overflowY: 'auto',
    },
    messageRow: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 1,
    },
    messageRowUser: {
        alignItems: 'flex-end',
    },
    messageBubble: {
        display: 'flex',
        flexDirection: 'column',
        width: 'fit-content',
        maxWidth: '75%',
        padding: '8px 12px',
        borderRadius: '16px',
        backgroundColor: theme.brand.field,
        color: theme.palette.text.primary,
        boxShadow: theme.shadows[1],
        alignSelf: 'flex-start',
        wordBreak: 'break-word',
        overflowWrap: 'anywhere',
        gap: '4px',
        '& .MuiTypography-root': {
            color: 'inherit',
            fontSize: '0.9rem',
            whiteSpace: 'pre-wrap',
        },
    },
    messageBubbleUser: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        alignSelf: 'flex-end',
        '& .MuiTypography-root': {
            color: theme.palette.common.white,
            fontSize: '0.9rem',
            whiteSpace: 'pre-wrap',
        },
    },
    typingBubble: {
        opacity: 0.75,
        fontStyle: 'italic',
    },
    messageMeta: {
        marginTop: 0,
        fontSize: '0.8rem',
        color: theme.palette.text.secondary,
        lineHeight: 1.1,
        opacity: 0.8,
    },
    inputContainer: {
        padding: '12px 20px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        borderTop: `1px solid ${theme.brand.field}`,
        backgroundColor: theme.palette.background.default,
        boxSizing: 'border-box',
    },
    disclaimer: {
        padding: '0 20px 12px',
        fontSize: '0.6rem',
        lineHeight: 1.3,
        color: theme.palette.text.secondary,
        opacity: 0.8,
        textAlign: 'center',
        textWrap: 'pretty',
        backgroundColor: theme.palette.background.default,
    },
    inputField: {
        flex: 1,
        minWidth: 0,
        '& .MuiInputBase-root': {
            height: 44,
            borderRadius: '12px',
        },
        '& .MuiInputBase-input': {
            padding: '10px 14px',
            fontSize: '0.9rem',
        },
        '& .MuiInputBase-input::placeholder': {
            fontSize: '0.9rem',
            opacity: 0.8,
        },
    },
    sendButton: {
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.common.white,
        width: 44,
        height: 44,
        borderRadius: '50%',
        padding: 0,
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        },
    },
    sendButtonDisabled: {
        backgroundColor: theme.brand.field,
        color: theme.palette.text.secondary,
        '&:hover': {
            backgroundColor: theme.brand.field,
        },
    },
    fab: {
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        },
    },
    fabOpen: {
        backgroundColor: theme.palette.primary.main,
    },
});
